// src/encounter/note-conflict-notice.tsx
// The main note's save was refused because another writer changed the stored note (409 `version-conflict` or
// `not-current-revision`). The page keeps the clinician's answers and stops autosaving; this banner asks before the
// next save goes out on the version the server holds now.
//
// Presentational only: the page owns the conflict state and the save.
import { Banner, Button } from '@scripsteam/scrips-signal-ds';

export interface NoteConflictNoticeProps {
  /** True while the conflict stands; false renders nothing. */
  conflict: boolean;
  /** The stored note is being read again: "Save again" waits for it. */
  busy?: boolean;
  /** Save the clinician's answers again, on the version the server holds now. */
  onSaveAgain: () => void;
}

export function NoteConflictNotice({ conflict, busy = false, onSaveAgain }: NoteConflictNoticeProps) {
  if (!conflict) return null;
  return (
    <Banner
      variant="warning"
      data-testid="note-conflict"
      action={
        <Button variant="secondary" size="sm" onClick={onSaveAgain} disabled={busy}>
          Save again
        </Button>
      }
    >
      This note was changed somewhere else. Your answers are still here.
    </Banner>
  );
}
